/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_LabelInputs */

const fr_rooms_label = /** @type {(inputs: Rooms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libellé`)
};

const en_rooms_label = /** @type {(inputs: Rooms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Rooms_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_label = /** @type {((inputs?: Rooms_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_label(inputs)
	return en_rooms_label(inputs)
});